import React from 'react';

const Warning = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" {...props}>
    <path
      fillRule="evenodd"
      d="M17.999 18c1.657 0 2.33-1.16 1.495-2.602L11.506 1.602c-.832-1.437-2.178-1.442-3.012 0L.506 15.398C-.326 16.835.343 18 2.001 18H18zM10 16c-.552 0-1-.444-1-1 0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1zm-1-4V5h2v7H9z"
    />
  </svg>
);

export default Warning;
